import { defineMessages } from 'react-intl';

export const messages: {
	confirmButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	cancelButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	confirmButton: {
		id: 'conversation-assistant-message-actions.studio-landing-page-redirect.confirm-button',
		defaultMessage: 'Confirm',
		description: 'Button to confirm the action to redirect to the studio landing page',
	},
	cancelButton: {
		id: 'conversation-assistant-message-actions.studio-landing-page-redirect.cancel-button',
		defaultMessage: 'Cancel',
		description: 'Button to cancel the action to redirect to the studio landing page',
	},
});
